import { userActions, UserFormData } from "../../slices/userSlice";
import { passwordFormModes } from "./modes";

export const modesData = {
  [passwordFormModes.set]: {
    titleTrKey: "registerForm.title",
    dispatchAction: userActions.registerConfirm,
    sendAuthMessageAgainAction: (formData: UserFormData) => {
      const { policyNo, pid } = formData;
      return userActions.registerInit({ policyNo, pid });
    },
  },
  [passwordFormModes.change]: {
    titleTrKey: "changePasswordForm.title",
    dispatchAction: userActions.passwordResetConfirm,
    sendAuthMessageAgainAction: (formData: UserFormData) =>
      userActions.passwordResetInit({ username: formData.username }),
  },
  [passwordFormModes.reset]: {
    titleTrKey: "resetPasswordForm.title",
    dispatchAction: userActions.passwordResetConfirm,
    sendAuthMessageAgainAction: (formData: UserFormData) =>
      userActions.passwordResetInit({ username: formData.username }),
  },
};

export const newPasswordValidationConditions = [
  {
    labelTrKey: "passwordForm.validatorConditions.min12Max50Char",
    testFn: (phrase: string) => phrase.length >= 12 && phrase.length <= 50,
  },
  {
    labelTrKey: "passwordForm.validatorConditions.minOneUppercase",
    testFn: (phrase: string) => /[A-ZĘÓĄŚŁŻŹĆŃ]/.test(phrase),
  },
  {
    labelTrKey: "passwordForm.validatorConditions.minOneDigit",
    testFn: (phrase: string) => /\d/.test(phrase),
  },
  {
    labelTrKey: "passwordForm.validatorConditions.minOneSpecial",
    testFn: (phrase: string) => /[-!$%^&*()"'/\\_+|~=`{}[:;<>?,.@#\]]/g.test(phrase),
  },
];
